/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useContext,
  useRef,
  FC,
  Children,
} from 'react';
import { css, jsx } from '@emotion/core';
import { interactionContext } from './interactionContext';
import EditCardWrapper from './EditCardWrapper';
import Masonry from './Masonry';
import { grids } from './grids';

const ContentCards = ({ children, ...props }) => {
  const context: any = useContext(interactionContext);

  let { grid, numColumns, uniformHeight } = context.props;
  const gridContainer = useRef<HTMLDivElement | null>(null);

  const cardOrder = useRef<string>('');
  cardOrder.current = Children.map(children, (child: any, index) => {
    const { props } = child.props.children[1];

    const { id } = props;
    return id;
  }).join();

  const images: string[] = [];

  const imagesInCards = cards => {
    [...cards].forEach((card: React.ReactElement) => {
      if (card && card.props) {
        if (card.props.child === 1) {
          !images.includes(card.props.src) && images.push(card.props.src);
        }

        if (card.props.children && card.props.children.length) {
          imagesInCards(card.props.children);
        }
      }
    });
  };

  imagesInCards(children);

  if (['masonry', 'uniformHeight'].includes(grid)) {
    return (
      // @ts-ignore
      <Masonry
        key={`masonry_${Children.count(children)}_${numColumns}_${grid}_${
          cardOrder.current
        }`}
        maxColumns={numColumns}
        maxGridWidth={1100}
        minCellWidth={320}
        images={images}
        uniformHeight={grid === 'uniformHeight'}
      >
        {Children.map(children, (child: any, index: number) => {
          return (
            <div
              key={child.props.id}
              css={css({
                position: 'relative',
                padding: '20px',
                ...(grid === 'uniformHeight' && {
                  height: '100%',
                  '.card': {
                    height: '100%',
                  },

                  //
                }),
              })}
            >
              {window.dev && window.dev() && (
                <EditCardWrapper id={child.props.id} />
              )}
              {React.cloneElement(child, {
                parentId: (props as any).id,
                className: `card-${index}`,
                ...(grid === 'bannerColumns' &&
                  {
                    //
                  }),
              })}
            </div>
          );
        })}
      </Masonry>
    );
  }

  return (
    <div
      ref={gridContainer}
      css={css({
        ...css(grids(grid, { numColumns, children })),
        width: '100%',
        height: '100%',
      })}
    >
      {Children.map(children, (child: any, index: number) => {
        const className = `grid-cell-${index}`;

        return (
          <div
            key={className}
            className={className}
            css={css({
              position: 'relative',
              padding: '20px',

              ...(['uniformHeight'].includes(grid) && {
                '> div': {
                  height: '100%',
                },
              }),

              ...(['bannerColumns'].includes(grid) && {
                '> div': {
                  height: '100%',
                },
              }),
            })}
          >
            {window.dev && window.dev() && (
              <EditCardWrapper id={child.props.id} />
            )}
            {React.cloneElement(child, {
              parentId: (props as any).id,
              className: `card-${index}`,
              ...(grid === 'bannerColumns' &&
                index === 0 && {
                  checkBannerColumnsForDefaultImage: true,
                }),
            })}
          </div>
        );
      })}
    </div>
  );
};

export default ContentCards;
